'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import Image from 'next/image';
import { ImageObj } from '@custom-types/ImageObj.types';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import SplideSlider from '@components/SplideSlider';
import cn from './style.module.scss';
interface VillasLaunchGalleryProps {
  t: any;
  galleryImages: Array<ImageObj>;
  galleryMobileSlideImages: Array<ImageObj>;
  galleryClipImage: ImageObj;
}
const villasLaunchGallerySettings = {
  type: 'fade',
  rewind: true,
  autoplay: true,
  speed: 900,
  perMove: 1,
  perPage: 1,
  start: 1,
  drag: false,
};
export default function VillasLaunchGallery(props: VillasLaunchGalleryProps) {
  const { t } = props;
  return (
    <Stack component="section" className={cn.welcomeGallery}>
      <Box className={cn.welcomeGallerySlides}>
        {props.galleryImages.length > 1 ? (
          <>
            <Mobile>
              <SplideSlider
                options={villasLaunchGallerySettings}
                className="orientalSlider"
              >
                {props.galleryMobileSlideImages.map((image, index) => (
                  <Box
                    component="picture"
                    key={index}
                    className={cn.sliderGalleryStory}
                  >
                    <Image
                      src={image.url}
                      alt={`Villas Launch Gallery - Gallery Mobile Slide Images ${index + 1}`}
                      layout="responsive"
                      width={600}
                      height={400}
                    />
                  </Box>
                ))}
              </SplideSlider>
            </Mobile>
            <Desktop>
              <SplideSlider
                options={villasLaunchGallerySettings}
                className="orientalSlider"
              >
                {props.galleryImages.map((image, index) => (
                  <Box
                    component="picture"
                    key={index}
                    className={cn.sliderGalleryStory}
                  >
                    <Image
                      src={image.url}
                      alt={`Villas Launch Gallery - Gallery Images ${index + 1}`}
                      layout="responsive"
                      width={600}
                      height={400}
                    />
                  </Box>
                ))}
              </SplideSlider>
            </Desktop>
          </>
        ) : (
          <>
            <Mobile>
              <Box component="picture" className={cn.sliderGalleryStory}>
                <Image
                  src={props.galleryImages[0].url}
                  alt={`Villas Launch Gallery - Gallery Images`}
                  layout="responsive"
                  width={600}
                  height={400}
                />
              </Box>
            </Mobile>
            <Desktop>
              <Box component="picture" className={cn.sliderGalleryStory}>
                <Image
                  src={props.galleryImages[0].url}
                  alt={`Villas Launch Gallery - Gallery Images`}
                  layout="responsive"
                  width={600}
                  height={400}
                />
              </Box>
            </Desktop>
          </>
        )}
      </Box>
    </Stack>
  );
}
